<template>
    <div class="sessionOver">
        <v-dialog
            v-model="showDialog"
            width="500"
        >
            <div v-if="showUserDetails && !isLoading">
                <ValidationObserver slim v-slot="{ invalid }">
                    <v-card>
                        <v-card-title>
                            <div v-if="!editDetails" style='color: #232323; font-weight: bold; font-family-Inter'>
                            Add Nominee
                            </div>
                            <div v-if="editDetails" style='color: #232323; font-weight: bold; font-family-Inter'>
                            Edit Nominee Details
                            </div>
                            <v-icon @click="closeDialog" style="color: #000000">
                                fas fa-times
                            </v-icon>
                        </v-card-title>
                        <ValidationProvider
                            name="Name"
                            :rules="nameRules"
                            v-slot="{ errors, classes }"
                        >
                            <v-card-text style="display: flex; padding: 12px; flex-direction: column; justify-content: center; align-content: center;">
                                <div class="input-group" :class="classes">
                                    <input
                                        type="text"
                                        @keypress="validateName"
                                        class="form-control amount"
                                        v-model="name"
                                        placeholder="Name"
                                    />
                                </div>
                                <small class="form-group--error-message">{{ errors[0] }}</small>
                            </v-card-text>
                        </ValidationProvider>
                        <ValidationProvider
                            name="Phone Number"
                            :rules="phoneRules"
                            v-slot="{ errors, classes }"
                        >
                            <v-card-text style="display: flex; padding: 12px; flex-direction: column; justify-content: center; align-content: center;">
                                <div class="input-group" :class="classes">
                                    <input
                                        type="number"
                                        onKeyPress="if(this.value.length==10) return false;"
                                        class="form-control amount"
                                        v-model="phoneNumber"
                                        placeholder="Phone Number"
                                    />
                                </div>
                                <small class="form-group--error-message">{{ errors[0] }}</small>
                            </v-card-text>
                        </ValidationProvider>
                        <ValidationProvider
                            name="PAN"
                            :rules="panRules"
                            v-slot="{ errors, classes }"
                        >
                            <v-card-text style="display: flex; padding: 12px; flex-direction: column; justify-content: center; align-content: center;">
                                <div class="input-group" :class="classes">
                                    <input
                                        style="text-transform:uppercase"
                                        type="text"
                                        maxlength="10"
                                        class="form-control amount"
                                        v-model="pan"
                                        placeholder="PAN"
                                    />
                                </div>
                                <small class="form-group--error-message">{{ errors[0] }}</small>
                            </v-card-text>
                        </ValidationProvider>
                        <Validation-provider
                            v-slot="{ errors }"
                            name="Relationship"
                            rules="required"
                        >
                            <v-card-text style="display: flex; padding: 12px; flex-direction: column; justify-content: center; align-content: center; font-size: 12px">
                                    <v-select
                                        v-model="relationship"
                                        :items="relationOptions"
                                        :error-messages="errors"
                                        label="Relation with nominee"
                                        outlined
                                        required
                                    >
                                    </v-select>
                            </v-card-text>
                        </Validation-provider>
                        <v-card-actions>
                            <button style="height: 45px; width:50%; margin-left:25%; margin-right:25%;"
                                class="btn btn-secondary w-150px mb-15"
                                @click="SubmitData"
                                v-if="!editDetails"
                                :disabled="invalid"
                            >
                                <span v-if="disableButton">
                                    Add Nominee
                                </span>
                                <v-progress-circular
                                    v-else
                                    indeterminate
                                    color="amber"
                                ></v-progress-circular>
                            </button>
                            <button style="height: 45px; width:50%; margin-left:25%; margin-right:25%;"
                                class="btn btn-secondary w-150px mb-15"
                                @click="updateDetails"
                                v-if="editDetails"
                                :disabled="invalid"
                            >
                                <span v-if="disableButton">
                                    Update details
                                </span>
                                <v-progress-circular
                                    v-else
                                    indeterminate
                                    color="amber"
                                ></v-progress-circular>
                            </button>
                        </v-card-actions>
                    </v-card>
                </ValidationObserver>
        </div>
        <div v-if="!showUserDetails && !isLoading">
            <v-card>
                <v-card-title>
                    <div style='color: #232323; font-weight: bold; font-family-Inter'>
                    Nominee Details
                    </div>
                    <v-icon @click="closeDialog" style="color: #000000">
                        fas fa-times
                    </v-icon>
                </v-card-title>
                <div style ='width: max-content; height: 180px; padding-left: 40px;'>
                    <v-card-text class = "cardDetails">
                        Name: <strong>{{userNominee.name}}</strong>
                        <v-icon
                        class = "editIcon"
                        @click="updateNomineeDetails">
                            fa-light fa-pen
                        </v-icon>
                    </v-card-text>
                    <v-card-text class = "cardDetails">
                        Relation: <strong>{{userNominee.relationship}}</strong>
                    </v-card-text>
                    <v-card-text class = "cardDetails">
                        Phone Number: <strong>+91-{{userNominee.phoneNumber}}</strong>
                    </v-card-text>
                    <v-card-text class = "cardDetails">
                        PAN: <strong>{{userNominee.pan}}</strong>
                    </v-card-text>
                </div>
            </v-card>
        </div>
            <div v-if="isLoading">
                <v-card height="400">
                    <v-progress-circular
                        style="    height: 50px; width: 50px; left: 220px; top: 180px;"
                        indeterminate
                        color="amber"
                    ></v-progress-circular>
                </v-card>
            </div>
        </v-dialog>
        <v-snackbar v-model="showSnackBar" app timeout="-1">
            {{ snackBarContent }}
            <template v-slot:action="{ attrs }">
                <v-btn
                color="red"
                text
                v-bind="attrs"
                @click="showSnackBar = false"
            >
                Close
            </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>

import { bus } from '@/main'
import LenderService from '@/services/lenderService'
export default {
    name: 'NomineeDialog',
    components: {
    },
    data () {
        return {
            userNominee: {
                name: '',
                pan: '',
                phoneNumber: '',
                relationship: ''
            },
            relationOptions: ['Wife', 'Husband', 'Son', 'Daughter', 'Father', 'Mother', 'Brother', 'Sister', 'Grand father', 'Grand Mother'],
            name: '',
            pan: '',
            phoneNumber: '',
            relationship: '',
            showDialog: false,
            nameRules: 'required',
            phoneRules: 'length:10|numeric|required',
            panRules: 'length:10|required|alpha_num',
            snackBarContent: '',
            showSnackBar: false,
            disableButton: true,
            showUserDetails: true,
            isLoading: true,
            editDetails: false
        }
    },
    computed: {
    },
    async created () {
        bus.$on('nomineeDialog', (data) => {
            this.showDialog = true
            this.isLoading = true
            this.getUserData()
        })
    },
    methods: {
        updateDetails () {
            this.disableButton = false
            this.pan = this.pan.toUpperCase()
            const payload = {}
            if (this.name !== this.userNominee.name) {
                payload.name = this.name
            }
            if (this.pan !== this.userNominee.pan) {
                payload.pan = this.pan
            }
            if (this.relationship !== this.userNominee.relationship) {
                payload.relationship = this.relationship
            }
            if (this.phoneNumber !== this.userNominee.phoneNumber) {
                payload.phoneNumber = this.phoneNumber
            }

            if (Object.keys(payload).length === 0) {
                this.snackBarContent = 'Nothing to update'
                this.showSnackBar = true
                this.disableButton = true
                return
            }

            LenderService.editNomineeDetails(payload).then((response) => {
                if (response.status === 200) {
                    this.snackBarContent = 'Nominee details updated successfully!'
                    this.showSnackBar = true
                    setTimeout(() => {
                        this.showDialog = false
                        location.reload()
                    }, 1)
                } else {
                    this.showDialog = false
                    this.snackBarContent = 'Failed to update Nominee details!'
                    this.showSnackBar = true
                }
                this.disableButton = false
            })
        },
        validateName: (event) => {
            var keyCode = event.keyCode
            if (keyCode >= 48 && keyCode <= 57) {
                event.preventDefault()
            }
        },
        validateNumber: (event) => {
            var keyCode = event.keyCode
            if (keyCode < 48 && keyCode > 57) {
                event.preventDefault()
            }
            if (event.value.length === 10) {
                event.preventDefault()
            }
        },
        updateNomineeDetails () {
            this.isLoading = true
            this.editDetails = true
            this.showUserDetails = true
            this.isLoading = false
            this.name = this.userNominee.name
            this.pan = this.userNominee.pan
            this.phoneNumber = this.userNominee.phoneNumber
            this.relationship = this.userNominee.relationship
        },
        getUserData () {
            LenderService.getUserNomineeData().then((response) => {
                if (response.status === 200) {
                    this.isLoading = false
                    if (response.data.result.nomineeDetails) {
                        this.showUserDetails = false
                        this.userNominee.name = response.data.result.nomineeDetails.name
                        this.userNominee.pan = response.data.result.nomineeDetails.pan
                        this.userNominee.phoneNumber = response.data.result.nomineeDetails.phoneNumber
                        this.userNominee.relationship = response.data.result.nomineeDetails.relationship
                    } else if (response.status === 400) {
                        this.snackBarContent = 'Nominee Details already exists'
                        this.showSnackBar = true
                    } else {
                        this.showUserDetails = true
                    }
                } else {
                    this.snackBarContent = 'Failed to load Nominee Data'
                    this.isLoading = false
                    this.showSnackBar = true
                }
            })
        },
        SubmitData () {
            this.disableButton = false
            this.pan = this.pan.toUpperCase()
            this.isButtonDisabled = true
            const payload = {
                name: this.name,
                pan: this.pan,
                phoneNumber: this.phoneNumber,
                relationship: this.relationship
            }
            LenderService.addNomineeDetails(payload).then((response) => {
                if (response.status === 200) {
                    this.snackBarContent = 'Nominee added successfully!'
                    this.showSnackBar = true
                    setTimeout(() => {
                        this.showDialog = false
                        location.reload()
                    }, 1)
                } else {
                    this.showDialog = false
                    this.snackBarContent = 'Failed to add Nominee!'
                    this.showSnackBar = true
                }
                this.disableButton = false
            })
        },
        closeDialog () {
            this.showDialog = false
            this.name = ''
            this.relationship = ''
            this.pan = ''
            this.phoneNumber = ''
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@/sass/components/registration-flow.scss";
@import "@/components/dashboard/dashboard.scss";

.nomineeCard {
    background: white !important;
}

.cardDetails{
    width: 100%;
    height: 20px;
    font-size: 0.85em;
    color: #232323;
    font-weight: medium
}

.editIcon {
    font-size: 18px;
    width: 18px;
    height: 18px;
    position: relative;
    left: 55%;
    right: 12.49%;
    top: 12.49%;
    bottom: 12.5%;
}

.v-card {
    width: 100%;
    height: 100%;
    background: white !important;
    color: $primary !important;
}
.v-card__title {
    justify-content: space-between;
}

.v-dialog > .v-card > .v-card__subtitle {
    padding: 6px 24px;
}

.v-dialog > .v-card > .v-card__text {
    color: $primary !important;
    padding: 6px 24px 0px;
}

.v-card__actions{
    justify-content: center;
    @media (min-width: 992px) {
        justify-content: flex-end;
    }
}

::v-deep .v-input__slot {
    min-height: 45px !important;
}

::v-deep .v-select__slot {
    bottom: 3px !important
}

::v-deep .v-input.v-input--has-state.theme--light.v-text-field.v-text-field--is-booted.v-text-field--enclosed.v-text-field--outlined.v-select.error--text {
    color: #E45F5F !important;
    caret-color: #E45F54 !important;
}

::v-deep .v-messages__message {
    color: #E45F5F !important;
    caret-color: #E45F54 !important;
}

.amount {
    font-size: 16px !important;
    border-top-color: rgba(0, 0, 0, 0.42);
    border-right-color: rgba(0, 0, 0, 0.42);
    border-bottom-color: rgba(0, 0, 0, 0.42);
    border-left-color: rgba(0, 0, 0, 0.42);
}

</style>
